<template>
  <div class="main">
    <media-header-join></media-header-join>
    <div class="main-header">
      <el-row :gutter="10" style="
          display: flex;
          justify-content: flex-end;
          padding-top: calc(100vw * 80 / 1920);
        ">
        <el-col :lg="10" :sm="6" style="display: flex;">
          <img @click="toIndex()" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_logo.png"
               style="width: calc(100vw * 200 / 1920); height: calc(100vw * 85 / 1920)"/>
        </el-col>

        <el-col :lg="14" :sm="18" class="navbar">
          <div v-for="(item, index) in titles" :key="index" :class="item.selected ? 'title_selected' : ''" class="title"
               @click="toPage(item)">
            {{ item.title }}
          </div>
          <div class="title">
            <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: calc(100vw * 50 /1920);
                height: calc(100vw * 50 /1920);
                border-radius: 50%;
                background-color: #4063f9;
                margin-top: calc(100vw * -10 /1920);
              ">
              <img src="../assets/icon/search.png" style="width: calc(100vw * 35 /1920); height: calc(100vw * 35 /1920)"/>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

      <el-main>
        <el-row class="main-student" :gutter="10" style="
          margin-top: calc(100vw * 60 /1920);
          display: flex;
          justify-content: flex-start;
          padding: 0 calc(100vw * 20 /1920) calc(100vw * 80 /1920) calc(100vw * 20 /1920);
        ">
          <div class="item-face"></div>
          <div class="item-judge">
            <div class="item-student">Join us</div>
            <div v-for="(item, index) in details" :key="index" class="item-detail">
              <div
                class="item-detail-content"
                v-html="formatContent(item.content)"
              ></div>
              <div style="text-align: right">{{ item.student }}</div>
            </div>
          </div>
        </el-row>

        <!-- 768像素下显示的内容 -->
        <el-row class="media-768-student" :gutter="10">
          <div class="item-face">
            <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/joinus_face.png" alt="" />
          </div>
          <div class="item-judge">
            <div v-for="(item, index) in details" :key="index" class="item-detail">
              <div
                class="item-detail-content"
                v-html="formatContent(item.content)"
              ></div>
            </div>
          </div>
        </el-row>

          <div class="job-line">
            <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/line-radius.png" alt="" />
          </div>
       
        <el-row class="main-footer" :gutter="10" style="margin-top: calc(100vw * 60 /1920)">
          <img
          :src="require('@/assets/image/footer_join.png')"
          style="width: 100%; display: block;"
          />
        </el-row>
      </el-main>
  </div>
</template>

<style>
.highlight {
  color: #4063f9;
  font-weight: 600;
}
</style>

<script>
import mediaHeaderJoin from './media/mediaHeaderJoin'
export default {
  name: "Index",
  components: {
    mediaHeaderJoin
  },
  data() {
    return {
      titles: [
        //'Research','People','Science And Art','Join Us','Contact Us'
        {
          title: "Research",
          key: "Research",
        },
        {
          title: "People",
          key: "People",
        },
        {
          title: "Science And Art",
          key: "Science",
        },
        {
          title: "Join us",
          key: "Joinus",
          selected: true,
        },
        {
          title: "Contact us",
          key: "Contactus",
        },
      ],
      current: 2,
      details: [
        //
        {
          content:
            "We are an interdisciplinary research group.\nWe are interested in how neural network gives rise to behavior.",
        },
        {
          content: "Our mission is to pursuit FACTS",
        },
        {
          content:
            " Fundamental\n我们要揭示自然界最本质的原理",
        },
        {
          content:
            "Aesthetic\n我们要揭示科学的美，滋养我们自己心灵的同时传播美好",
        },
        {
          content:
            "Connected\n我们要成为能够与人连接的良性种子，在人类社会中发挥正向作用",
        },
        {
          content:
            "Technique\n我们要让自己精通某项技术，成为自己谋生的根本，并对世界有用",
        },
        {
          content:
            "Self-actualization\n我们在这里学习工作成为更好的自己",
        },
        {
          content:
            "If you share our interests and have skills to contribute to our interdisciplinary research group, you may contact PI for further information.",
        },
      ],
    };
  },
  methods: {
    toPage(item) {
      this.$router.push(item.key);
    },
    toIndex() {
      this.$router.push({ path: "/" });
    },
    formatContent(content) {
      if (!content) return '';

      // 先处理换行
      let html = content.replace(/\n/g, '<br>');

      // 需要“首字母高亮”的行首关键词
      const lineStartWords = [
        'Fundamental',
        'Aesthetic',
        'Connected',
        'Technique',
        'Self-actualization'
      ];

      lineStartWords.forEach(word => {
        // 拆成：首字母 + 剩余部分
        const firstChar = word.charAt(0);
        const rest = word.slice(1);

        // 行首或 <br> 后出现
        const reg = new RegExp(`(^|<br>)\\s*${word}`, 'g');

        html = html.replace(
          reg,
          `$1<span class="highlight">${firstChar}</span>${rest}`
        );
      });

      // FACTS：整个单词全部高亮（保持你原本的设计）
      html = html.replace(
        /\bFACTS\b/g,
        '<span class="highlight">FACTS</span>'
      );

      return html;
    }

  }
};
</script>

<style scoped>
  img {
    object-fit: contain;
  }

.el-dropdown-menu__item:nth-child(4) {
  color: #4063f9 !important;
}

@media screen and (max-width: 1200px) {
  /*当屏幕尺寸小于1200px时，应用下面的CSS样式*/
  .main {
    width: 100%;
  }
}
/*当屏幕尺寸大于1200px时，应用下面的CSS样式*/
@media screen and (min-width: 1200px) {
  .main {
    width: 80%;
    margin-left: 10%;
  }
}

.main {
  overflow-x: hidden;
  overflow-y: hidden;
  text-rendering: optimizelegibility;
}

  .navbar {
    font-family: bahnschrift;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    cursor: pointer;
    letter-spacing: calc(100vw * -1 /1920);
  }

  .title {
    font-family: 'mon';
    font-size: calc(100vw * 20 / 1920);
    color: #4063f9;
    padding-top: calc(100vw * 10 / 1920);
    text-rendering: optimizelegibility;
  }

  .title_selected {
    font-weight: bold;
    position: relative;
    letter-spacing: calc(100vw * -1 / 1920);
  }


  .title_selected::after {
    content: "__";
    letter-spacing: calc(100vw * -1 /1920);
    color: #ff6a4a;
    font-weight: bold;
    position: absolute;
    left: calc(100vw * 10 / 1920);
    bottom: calc(100vw * 30 / 1920);
    font-size: calc(100vw * 25 / 1920);
  }

.item {
  background-color: #ffffff;
  width: 15%;
  height: 65%;
  border: calc(100vw * 1 /1920) solid #b4b4b4;
  margin: 0;
}

.selected {
  width: 20%;
  height: 75%;
  box-shadow: calc(100vw * 1 /1920) calc(100vw * 1 /1920) #b4b4b4;
}

.item-title {
  display: flex;
  justify-content: flex-start;
  font-size: calc(100vw * 45 /1920);
  color: #4063f9;
}

.bold {
  font-weight: bold;
}

.item-face {
  width: 50%;
  height: calc(100vw * 550 /1920);
  background: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/joinus_face.png") no-repeat;
  background-size: contain;
  background-position: 50% 50%;
}

.item-judge {
  width: 50%;
  text-align: left;
  padding-top: calc(100vw * 150 /1920);
}

.item-student {
  font-size:calc(100vw * 65 /1920);
  color: #3f64fa;
  font-weight: 800;
  padding-left: calc(100vw * 40 /1920);
}

.item-detail {
  color: #595757;
  padding: calc(100vw * 30 /1920) 0 0 calc(100vw * 30 /1920);
  font-size: calc(100vw * 18 /1920);
  line-height: calc(100vw * 30 /1920);
}

.el-header,
.el-footer {
  text-align: center;
  line-height: 30px;
}

.el-main {
  padding: 80px 0 0 0;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

@media screen and (min-width: 769px) and (max-width: 1400px) {
  .title {
    font-size: 14px !important;
  }

  .main-header {
    padding: 0 20px;
  }

  .title_selected::after {
    bottom: 10px;
  }
}

/* 超出768尺寸需要隐藏的样式 */
.media-768-student {
  display: none;
}
.job-line > img {
  display: none;
}
.header-hidden {
  display: none;
}

.media-768-header {
  display: none;
}

.media-768-footer {
  display: none;
}

@media screen and (max-width: 768px) {
  /* 在768像素下需要隐藏的样式 */

  .main-student {
    display: block;
  }
  .el-header {
    display: none;
  }
  .main-footer {
    display: none;
  }
  .media-768-handsImg {
    display: none;
  }

  /* 在768像素下修改的样式 */
  img {
    width: 100%;
    height: 100%;
  }

  .media-768-student {
    display: block !important;
    padding: 0 29px;
  }
  .media-768-student > .item-face {
    width: 70%;
    background: #fff;
    height: auto;
    position: relative;
  }


  .item-judge {
    width: 100%;
  }
  .item-detail {
    font-size: 11px;
    padding: 0 15px;
    line-height: 30px;
    display: block;
  }

  .item-detail-content {
    display: block;           /* 关键 */
    white-space: normal;      /* 明确恢复 */
  }

  /* 研究生 */
  .media-768-consider {
    display: block !important;
  }
  .media-768-consider > div {
    width: 100% !important;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
}

@media screen and (min-width: 3000px) {
  * {
    font-size: calc(100vw * 16 / 1920) !important;
    line-height: calc(100vw * 30 / 1920) !important;
  }

  .search_icon {
    width: calc(100vw * 28 / 1920) !important;
    height: calc(100vw * 28 / 1920) !important;
  }

  .title {
    font-size: calc(100vw * 20 / 1920) !important;
    line-height: calc(100vw * 25 / 1920) !important;
  }

  .title > div {
    width: calc(100vw * 50 / 1920) !important;
    height: calc(100vw * 50 / 1920) !important;
  }

  .title img{
    width: 70% !important;
    height: 70% !important;
  }

  .title-icon {
    width: calc(100vw * 28 / 1920) !important;
    height: calc(100vw * 28 / 1920) !important;
  }

  .title_selected::after {
    line-height: calc(100vw * 30 / 1920) !important;
  }

  .item-face {
    height: calc(100vw * 700 / 1920) !important;
  }
  .main {
    width: 70%;
    margin: 0 auto;
  }

  .handsImg {
    display: flex;
    justify-content: flex-end;
  }

  .item-student {
    font-size: calc(100vw * 53 / 1920) !important;
    line-height: calc(100vw * 63 / 1920) !important;
  }

  .media-768-accpetTit {
    width: calc(100vw * 150 / 1920) !important;
    height: calc(100vw * 60 / 1920) !important;
    font-size: calc(100vw * 26 / 1920) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Joinus.vue